// src/hooks/useInsuranceEligibility.ts

import { useCallback } from "react";

import type {
  ActivityLog,
  EligibilityVerification,
} from "../contexts/InsuranceContextType";

interface UseInsuranceEligibilityOptions {
  setEligibilityVerifications: React.Dispatch<
    React.SetStateAction<EligibilityVerification[]>
  >;

  logActivity: (
    activity: Omit<
      ActivityLog,
      "id" | "timestamp"
    >
  ) => void;
}

interface UseInsuranceEligibilityReturn {
  addEligibilityVerification: (
    verificationData: Omit<
      EligibilityVerification,
      "id" | "createdAt" | "updatedAt"
    >
  ) => Promise<void>;

  updateEligibilityVerification: (
    id: string,
    updates: Partial<EligibilityVerification>
  ) => Promise<void>;
}

const createVerificationId = (): string => {
  const year = new Date().getFullYear();

  return `EV-${year}-${Date.now()
    .toString()
    .slice(-6)}`;
};

export function useInsuranceEligibility({
  setEligibilityVerifications,
  logActivity,
}: UseInsuranceEligibilityOptions): UseInsuranceEligibilityReturn {
  const addEligibilityVerification =
    useCallback(
      async (
        verificationData: Omit<
          EligibilityVerification,
          "id" | "createdAt" | "updatedAt"
        >
      ) => {
          throw new Error(
            "This action is currently unavailable. Your changes have not been saved."
          );
        },
      [
        logActivity,
        setEligibilityVerifications,
      ]
    );

  const updateEligibilityVerification =
    useCallback(
      async (
        id: string,
        updates: Partial<EligibilityVerification>
      ) => {
          throw new Error(
            "This action is currently unavailable. Your changes have not been saved."
          );
        },
      [
        logActivity,
        setEligibilityVerifications,
      ]
    );

  return {
    addEligibilityVerification,
    updateEligibilityVerification,
  };
}